import { render } from "./TenanciesAdd.vue?vue&type=template&id=27cb5bf7&scoped=true&ts=true"
import script from "./TenanciesAdd.vue?vue&type=script&lang=ts"
export * from "./TenanciesAdd.vue?vue&type=script&lang=ts"

import "./TenanciesAdd.vue?vue&type=style&index=0&id=27cb5bf7&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27cb5bf7"]])

export default __exports__